import React, { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalBase: React.FC<React.PropsWithChildren<ModalProps & { title: string }>> = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-[60]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-3xl flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl">
          <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-3xl p-1"
            aria-label="Cerrar modal"
          >
            &times;
          </button>
        </header>
        <main className="p-8 overflow-y-auto text-gray-600 leading-relaxed">
            {children}
        </main>
      </div>
    </div>
  );
};

export const AboutUsModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const imageUrl = "https://lh3.googleusercontent.com/aida-public/AB6AXuDGtq9aqVC5GlIv-Awj-63B1-S8U_QZykvHxWe67nh5lKZQEZERpnE1axkzk7mJtXvwWM-BlZoQ5qEzydxzgCDdHNuUv9_nu0hO4EGJMtoP5cIfl7sa8uh1M3fCsFsEa3TsALAgz6nfS6zlJ_Huj9EzEItAPFoHoC71TQoluCLl34CcqF0Q_QnV6n1iLw_KMyFU51GQzijMkWdZHqidM1jiraVrLyZRFqi9-Du3-p2UUPG5tIkbVPwKZFABRVbScYPUBYzFIFMquW4";

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Quiénes Somos">
        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestra Misión</h3>
            <p className="text-slate-700 text-base leading-relaxed">
                Peritajes.EU es una plataforma dedicada a proporcionar informes periciales expertos para casos de accidentes, averías y otras situaciones legales en toda Europa. Nuestra misión es aportar pruebas técnicas objetivas y rigurosas para garantizar la defensa justa de nuestros clientes, complementando nuestros servicios legales de Multas.EU y Juzgados.EU.
            </p>
        </section>
        
        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestro Equipo</h3>
            <p className="text-slate-700 text-base leading-relaxed">
                Nuestro equipo está formado por expertos legales, profesionales de la tecnología y especialistas en atención al cliente apasionados por la defensa de los derechos de nuestros usuarios. Combinamos la experiencia legal con tecnología de vanguardia para ofrecer una experiencia fluida y eficiente.
            </p>
        </section>

        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestra Ubicación</h3>
            <p className="text-slate-700 text-base leading-relaxed mb-4">
                Nuestra oficina principal está ubicada en Andorra, una localización estratégica que nos permite gestionar eficientemente casos en toda Europa. Aunque operamos principalmente en línea, nuestra presencia física nos asegura poder coordinar eficazmente con profesionales legales y autoridades en todo el continente.
            </p>
            <div className="aspect-video overflow-hidden rounded-lg shadow-lg">
                <div 
                    className="h-full w-full bg-center bg-no-repeat bg-cover transition-transform duration-300 ease-in-out hover:scale-105" 
                    style={{ backgroundImage: `url("${imageUrl}")` }}
                    aria-label="Imagen de Andorra"
                ></div>
            </div>
        </section>

        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Contáctanos</h3>
            <p className="text-slate-700 text-base leading-relaxed">
                Para consultas, soporte o comentarios, por favor, contáctanos en <a className="text-blue-600 hover:underline font-medium" href="mailto:información@peritajes.eu">información@peritajes.eu</a>. Nos comprometemos a proporcionar una asistencia oportuna y útil a todos nuestros usuarios.
            </p>
        </section>
    </ModalBase>
  );
};